import styled from 'styled-components';
import { createHandler } from '@mews/std';
import { Sized } from '@optimus-web/common';
import { Component, Decision, getComponentToken, IconVariant } from '@optimus-web/local-tokens';

export const getIconSize = createHandler({
    small: 16,
    medium: 24,
    large: 32,
});

const getIconToken = getComponentToken(Component.Icon);

export const IconWrapper = styled.span<Required<Sized>>`
    font-size: 0;
    display: inline-block;
    width: ${(props) => getIconSize(props.size)}px;
    height: ${(props) => getIconSize(props.size)}px;
`;

interface StyledIconProps extends Required<Sized> {
    variant: IconVariant | 'default';
}

export const StyledIcon = styled.div<StyledIconProps>`
    width: ${(props) => getIconSize(props.size)}px;
    height: ${(props) => getIconSize(props.size)}px;
    pointer-events: none;

    path {
        fill: ${(props) =>
            props.variant === 'default' ? 'currentColor' : getIconToken(Decision.Color, { variant: props.variant })};
    }
`;
